import styled from 'react-emotion'

import Modal from 'components/Modal'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled(WidgetCardModal)`
  padding: ${themeVars.large};
  width: 300px;

  .title {
    display: flex;
    color: rgb(79, 93, 106);
    font-size: ${themeVars.medium};
    font-weight: ${themeVars.graphikWeightMedium};
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .icon {
      height: 22px;
      padding-right: ${themeVars.nano};
      .fill {
        fill: ${themeVars.lightGray};
      }
    }
  }

  .form {
    margin-top: ${themeVars.mini};

    .label {
      margin: ${themeVars.large} 0 ${themeVars.mini};

      &:first-child {
        margin-top: 0;
      }
    }

    .input {
      margin-bottom: ${themeVars.mini};

      &.last-child {
        margin-bottom: 0;
      }
    }

    .emailRow {
      display: flex;
      margin-bottom: ${themeVars.mini};

      .input {
        flex-grow: 1;
        margin-bottom: 0;
        margin-right: ${themeVars.mini};
      }

      .button {
        margin-right: 0;
        line-height: 30px;
      }
    }

    .tooltipTrigger {
      cursor: pointer;
      color: ${themeVars.linkColor};
    }

    .link {
      color: ${themeVars.linkColor};
      cursor: pointer;
      margin-top: ${themeVars.small};
      margin-bottom: ${themeVars.large};
    }
  }

  &&& {
    .buttons {
      display: flex;
      flex-direction: row-reverse;
      margin-top: ${themeVars.mini};
      .button {
        margin-left: ${themeVars.mini};
      }
    }
  }
`

function WidgetCardModal({ className, ...props }) {
  return <Modal contentClass={className} {...props} />
}
